import { connectModal } from 'redux-modal';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { pipe } from 'ramda';

import { authLogout } from 'store/actionCreators/auth';
import { userAcceptAgreement } from 'store/actionCreators/user';
import { ACCEPT_USER_AGREEMENT } from 'constants/modals';
import UserLicenseAgreementPopup from './UserLicenseAgreementPopup';

const mapDispatchToProps = {
  userAcceptAgreement,
  authLogout,
};

export default pipe(
  connect(
    null,
    mapDispatchToProps,
  ),
  connectModal({ name: ACCEPT_USER_AGREEMENT }),
  withTranslation(),
)(UserLicenseAgreementPopup);
